export default __webpack_public_path__ + "static/media/stud-labs-collection-genesis.d65ccf98.jpg";